import React, { useEffect } from "react";
import { AgGridReact } from "@ag-grid-community/react";
import dimensions from "../../../../../util/dimensions-util";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import "@ag-grid-community/core/dist/styles/ag-grid.css";
import "@ag-grid-community/core/dist/styles/ag-theme-alpine.css";
import UTIL from '../../../../../util';

// Icons
import posIcon from "../../../../../assets/images/Fireboard/POS.png";
import kioskIcon from "../../../../../assets/images/Fireboard/kiosk.png";
import curbSideIcon from "../../../../../assets/images/Fireboard/curbside.png";
import onlineIcon from "../../../../../assets/images/Fireboard/online.png";
import walkupIcon from "../../../../../assets/images/Fireboard/walkup.png";
import textToPayIcon from "../../../../../assets/images/Fireboard/callin.png";
import scanToPayIcon from "../../../../../assets/images/Fireboard/payNow.png";
import newIcon from "../../../../../assets/images/Fireboard/new.png";
import ordinaryIcon from "../../../../../assets/images/Fireboard/ordinary.png";

import classes from "./ChecksList.module.css";
import classNames from "classnames";
import SearchBox from "../../SearchBox";
import CalendarFilter from "../../CalendarFilter";
import extraButton from "../../../../../assets/images/Fireboard/action.png";
import payNowPound from "../../../../../assets/images/Fireboard/payNowPound.png";
import successPrint from '../../../../../assets/images/Fireboard/print_success.png';
import failurePrint from '../../../../../assets/images/Fireboard/print_failure.png';
import pendingPrint from '../../../../../assets/images/Fireboard/print-white.png';

const { vw: widthConstant } = dimensions;

const dueTimeComparator = (time1, time2, nodeA, nodeB) => {
  if (nodeA.data.dueTimeForSorting === null && nodeB.data.dueTimeForSorting === null) {
    return 0;
  }
  if (nodeA.data.dueTimeForSorting === null) {
    return -1;
  }
  if (nodeB.data.dueTimeForSorting === null) {
    return 1;
  }
  if (gridAPI.sortFilter)
    return nodeA.data.dueTimeForSorting - nodeB.data.dueTimeForSorting;
  return nodeB.data.dueTimeForSorting - nodeA.data.dueTimeForSorting;
};

const getIcon = (sourceType) => {
  switch (sourceType) {
    case 0: // POS, DEFAULT
      return posIcon;

    case 1: //KIOSK
      return kioskIcon;

    case 5: // CURBSIDE
      return curbSideIcon;

    case 6: // ONLINE
      return onlineIcon;

    case 7: // WALKUP
      return walkupIcon;

    case 8: // TEXTTOPAY
      return textToPayIcon;

    case 9: // SCANTOPAY
      return scanToPayIcon;

    default:
      return ordinaryIcon;
  }
};
let gridAPI;
const ChecksList = ({

  checksRowData = [],
  setSelectedCheck = () => { },
  selectedItem = {},
  showSearchBox,
  value,
  onSearchReset,
  handleChange,
  searchChecks,
  selectedDate,
  onDateChange,
  onlineOrderAdvanceLimit,
  resetFilterCalendar,
  isFutureOrderType,
  managerMode,
  activeMgrFilter,
  currency = '$',
  sortFilter,
}) => {

  useEffect(() => {
    if (!!gridAPI) {
      gridAPI.sortFilter = sortFilter;
      gridAPI.ensureIndexVisible(selectedItem.rowIndex, null);
      const params = {
        columns: [
          'icon',
          'status',
          'phoneNumber',
          'ellapsedTime',
          'dueTime',
          'checkInTime',
          'deliverTo',
          'paid',
          'extraActions',
        ]
      }
      gridAPI.redrawRows(params);
    }
  }, [checksRowData, managerMode, selectedItem.rowIndex, sortFilter]);

  useEffect(() => {
    if (!!gridAPI) {
      gridAPI.ensureIndexVisible(selectedItem.rowIndex, null);
    }
  });

  const getChecksFiltered = () => {
    if (managerMode) {
      let filterFunction = () => true;
      switch (activeMgrFilter) {
        case 'pre-auth': {
          filterFunction = check => check.tickets && check.tickets.some(tkt => tkt.preAuth && tkt.ticketStatusId === 0 && check.unpaidAmount > 0);
          break;
        }
        case 'over-serve': {
          filterFunction = check => {
            return check.relatedNotifications.some(n => n.notificationTypeId === 15 && n.data.checkHeaderId === check.id);
          };
          break;
        }
        case 'id-check': {
          filterFunction = check => {
            return check.relatedNotifications.some(n => n.notificationTypeId === 14 && n.data.checkHeaderId === check.id);
          };
          break;
        }
        default: {
          filterFunction = () => true;
          break;
        }
      }
      return checksRowData && checksRowData.filter(filterFunction);
    }
    return checksRowData;
  }

  const PhoneAndCheckNumber = ({
    phoneNumber = "",
    checkNumber = "",
    rowSelected,
    highlightRow,
    storeName,
  }) => {
    const cellStyle = classNames({
      [classes.phoneAndCheckContainer]: true,
      [classes.selectedRow]: rowSelected,
      [classes.highlightRow]: highlightRow,
    });
    return (
      <div className={cellStyle}>
        <div
          className={classNames(
            `${classes.cellText}`,
            `${classes.phoneNumberStyle}`
          )}
        >
          {storeName}
        </div>
        <div className={classes.cellText}>{checkNumber}</div>
      </div>
    );
  };

  const Status = ({ status, color, isNew, rowSelected, highlightRow }) => {
    const cellStyle = classNames({
      [classes.statusContainer]: !isNew,
      [classes.statusNewContainer]: isNew,
      [classes.selectedRow]: rowSelected,
      [classes.highlightRow]: highlightRow,
    });
    return (
      <div className={cellStyle}>
        <span className={classes.paidCellText} style={{ color }}>
          {status}
        </span>
        {isNew && (
          <img
            src={newIcon}
            className={classNames(`${classes.iconSize}`, `${classes.newIcon}`)}
            alt="new"
          />
        )}
      </div>
    );
  };

  const PaidStatus = ({ paid, rowSelected, highlightRow, paidAmount, unpaidAmount, paidAmountChanged }) => {
    const cellStyle = classNames({
      [classes.centerWithPadding]: true,
      [classes.circle]: paid === 'partial',
      [classes.selectedRow]: rowSelected,
      [classes.highlightRow]: highlightRow,
      [classes.updatedRow]: paidAmountChanged,
    });
    return (
      <div className={cellStyle}>
        <img
          src={paid}
          className={classes.iconSize}
          alt="paid"
        />
      </div>
    );
  };

  const getOverlayContentTemplate = () => {
    return `<span class="ag-overlay-loading-center">Please wait while checks are loading</span>`;
  };

  const getOverlayNoRowsTemplate = () => {
    return `<span class="ag-overlay-loading-center">No checks available</span>`;
  };

  const columnDefs = [
    {
      headerName: "",
      field: "",
      cellRendererFramework: StatusIcon,
      // cellRendererParams: { managerMode: managerMode, currency: currency },
      resizable: true,
      width: 60 * widthConstant,
      flex: 1,
    },
    {
      headerName: "Status",
      field: "status",
      width: 140 * widthConstant,
      flex: 1,
      resizable: true,
      sortable: true,
      cellRendererFramework: ({
        data: { status = "", color = "", isNew = false, rowSelected = false, relatedNotifications, highlightRow = false },
      }) => {
        const cellStyle = rowSelected
          ? classes.centerWithSelected
          : classes.centerWithPadding;
        const hasIdCheckNotification =
          relatedNotifications && relatedNotifications.filter(n => n.notificationTypeId === 14);
        return (
          <div className={highlightRow ? [cellStyle, classes.highlightRow] : cellStyle}>
            {managerMode ? (
              hasIdCheckNotification && hasIdCheckNotification.length > 0 ? (
                <span className={classes.overServeText}>
                  ID CHECK
                </span>
              ) : null
            ) : (
              <Status
                status={status}
                color={color}
                isNew={isNew}
                rowSelected={rowSelected}
                highlightRow={highlightRow}
              />
            )}
          </div>
        );
      },
    },
    {
      headerName: "Number",
      field: "phoneNumber",
      width: 130 * widthConstant,
      resizable: true,
      flex: 1,
      sortable: true,
      cellRendererFramework: ({
        data: { checkNumber = "", phoneNumber = "", rowSelected = false, highlightRow = false, storeName },
      }) => {
        return (
          <PhoneAndCheckNumber
            phoneNumber={phoneNumber}
            checkNumber={checkNumber}
            rowSelected={rowSelected}
            highlightRow={highlightRow}
            storeName={storeName}
          />
        );
      },
    },
    {
      headerName: "Time",
      field: "ellapsedTime",
      width: 80 * widthConstant,
      resizable: true,
      flex: 1,
      sortable: true,
      cellRendererFramework: ({ data: { ellapsedTime, rowSelected, highlightRow } }) => {
        var btnClass = classNames({
          [classes.column]: true,
          [classes.selectedRow]: rowSelected,
          [classes.highlightRow]: highlightRow,
        });
        return <div className={btnClass}>{ellapsedTime}</div>;
      },
    },
    {
      headerName: "Due",
      field: "dueTime",
      width: 110 * widthConstant,
      resizable: true,
      flex: 1,
      sortable: true,
      comparator: dueTimeComparator,
      cellRendererFramework: ({ data: { dueTime, rowSelected, highlightRow } }) => {
        var cellStyle = classNames({
          [classes.column]: true,
          [classes.selectedRow]: rowSelected,
          [classes.highlightRow]: highlightRow,
        });
        return <div className={cellStyle}>{dueTime}</div>;
      },
    },
    {
      headerName: "Check In",
      field: "checkInTime",
      width: 150 * widthConstant,
      resizable: true,
      flex: 1,
      sortable: true,
      cellRendererFramework: ({ data: { checkInTime, rowSelected, highlightRow } }) => {
        const cellStyle = classNames({
          [classes.column]: true,
          [classes.selectedRow]: rowSelected,
          [classes.highlightRow]: highlightRow,
        });
        return <div className={cellStyle}>{checkInTime}</div>;
      },
    },
    {
      headerName: "Deliver To",
      field: "deliverTo",
      width: 130 * widthConstant,
      resizable: true,
      flex: 1,
      sortable: true,
      cellRendererFramework: ({ data: { deliverTo, rowSelected, highlightRow, deliverToChanged = false } }) => {
        const cellStyle = classNames({
          [classes.column]: true,
          [classes.selectedRow]: rowSelected,
          [classes.highlightRow]: highlightRow,
          [classes.updatedRow]: deliverToChanged,
        });
        return <div className={cellStyle}>{deliverTo}</div>;
      },
    },
    {
      headerName: "Paid",
      field: "paid",
      resizable: true,
      width: 60 * widthConstant,
      flex: 1,
      cellRendererFramework: ({ data: { paid, rowSelected, highlightRow = false, unpaidAmount, paidAmount, paidAmountChanged = false } }) => {
        return <PaidStatus
          paid={paid}
          unpaidAmount={unpaidAmount}
          paidAmount={paidAmount}
          rowSelected={rowSelected}
          highlightRow={highlightRow}
          paidAmountChanged={paidAmountChanged}
        />;
      },
    },
    {
      headerName: "",
      field: "extraActions",
      resizable: true,
      width: 60 * widthConstant,
      flex: 1,
      cellRendererFramework: ({
        data: { onHandleCheckActions, rowSelected, highlightRow },
      }) => {
        const cellStyle = classNames({
          [classes.centerWithPadding]: true,
          [classes.selectedRow]: rowSelected,
          [classes.highlightRow]: highlightRow,
        });
        return (
          <div className={cellStyle} onClick={onHandleCheckActions}>
            <img src={extraButton} className={classes.iconSize} alt="" />
          </div>
        );
      },
    },
  ];

  const onGridReady = params => {
    gridAPI = params.api;
    params.api.sizeColumnsToFit();
  }

  const onGridSizeChanged = (params) => {
    params.api.sizeColumnsToFit();
  }

  const onRowClicked = (data, rowIndex) => {
    setSelectedCheck({ ...data, rowIndex });
  }

  const getCheckListHeight = () => {
    if (showSearchBox && selectedDate && isFutureOrderType) return { height: '75%' };
    else if (showSearchBox) return { height: '87%' };
    else if (selectedDate && isFutureOrderType) return { height: '87%' };
    else return { height: '99%' };
  };

  const heightConstant = UTIL.round(window.innerHeight / 900);

  return (
    <div className={classes.checks}>
      {showSearchBox ? (
        <SearchBox
          value={value}
          onSearchReset={onSearchReset}
          handleChange={handleChange}
          searchChecks={searchChecks}
        />
      ) : null}
      {selectedDate && isFutureOrderType ? (
        <CalendarFilter
          selectedDate={selectedDate}
          onDateChange={onDateChange}
          onlineOrderAdvanceLimit={onlineOrderAdvanceLimit}
          resetFilterCalendar={resetFilterCalendar}
        />
      ) : null}
      <div
        style={getCheckListHeight()}
        className={classNames({
          [classes.defaultContainerStyle]: true,
          [classes.futureOrdersContainerStyle]: isFutureOrderType && checksRowData.length,
        })}
      >
        <AgGridReact
          onGridReady={onGridReady}
          onGridSizeChanged={onGridSizeChanged}
          columnDefs={columnDefs}
          rowData={getChecksFiltered()}
          rowClass={[classes.gridRowClass]}
          rowHeight={70 * heightConstant}
          headerHeight={80 * heightConstant}
          modules={[ClientSideRowModelModule]}
          onRowClicked={({ data, rowIndex }) => onRowClicked(data, rowIndex)}
          overlayNoRowsTemplate={getOverlayNoRowsTemplate()}
          overlayLoadingTemplate={getOverlayContentTemplate()}
          deltaRowDataMode={true}
          getRowNodeId={data => data.id}
        />
      </div>
    </div>
  );
};

export default ChecksList;
class StatusIcon extends React.Component {
  getIcon = (status) => {
    switch (status) {
      case 'Print Completed': return successPrint;
      case 'Print Failed': return failurePrint;
      case 'Not Printed': return pendingPrint;
      default: return pendingPrint;
    }
  }

  render() {
    const { data } = this.props;
    const { rowSelected, printStatus } = data || {};
    const cellStyle = classNames({
      [classes.statusNewContainer]: true,
      [classes.selectedRow]: rowSelected,
    });

    return (
      <div className={cellStyle}>
        <img src={this.getIcon(printStatus)} alt="status"
          className={classNames(`${classes.iconSize}`, `${classes.newIcon}`)}
        />
      </div>
    );
  }
}
